import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, canonical, ogImage, ogType, twitterHandle }) => {
  const siteName = 'Aqua Farina';
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const defaultDescription = 'Aqua Farina | Restaurant Italien Authentique aux Jardins de Carthage. Découvrez nos pizzas artisanales au feu de bois, pâtes fraîches et spécialités italiennes. Réservez votre table en ligne.';
  const metaDescription = description || defaultDescription;
  const defaultKeywords = 'restaurant, pizza, jardins de carthage, aqua farina, italien, tunis, menu';
  const metaKeywords = keywords ? `${defaultKeywords}, ${keywords}` : defaultKeywords;
  
  const siteUrl = 'https://aqua-farina.web.app'; // Replace with your actual domain if different

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      {canonical && <link rel="canonical" href={`${siteUrl}${canonical}`} />}

      {/* Open Graph tags (Facebook, LinkedIn, etc.) */}
      <meta property="og:type" content={ogType || 'website'} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:url" content={`${siteUrl}${canonical || ''}`} />
      {ogImage && <meta property="og:image" content={ogImage} />}

      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {twitterHandle && <meta name="twitter:site" content={twitterHandle} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      
      {/* Structured Data (JSON-LD) for Restaurant */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Restaurant",
          "name": "Aqua Farina",
          "image": "https://aqua-farina.web.app/favicon.png",
          "url": siteUrl,
          "telephone": "+21626773104",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Jardins de Carthage",
            "addressLocality": "Tunis",
            "addressRegion": "Tunis",
            "postalCode": "1090",
            "addressCountry": "TN"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 36.849088792956124,
            "longitude": 10.297577058565748
          },
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday"
              ],
              "opens": "12:00",
              "closes": "23:00"
            }
          ],
          "menu": `${siteUrl}/menu`,
          "servesCuisine": "Italian, Pizza",
          "priceRange": "$$"
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
